let baseUrl = `${window.location.protocol}//${window.location.host}`;
if (baseUrl.includes("localhost")) baseUrl = "https://dev-paiyhub.4pay.ca";
export var serviceUrl = baseUrl + "/php/Workflows/services.php?output=json";
export var LOANS_ACCOUNT_NO = 16334;